import React, { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { ClipboardList, ShoppingCart } from 'lucide-react'
import { PageHeader } from '../../../components/StandardPage'
import { Content } from './style'

const PURCHASE_BASE = '/panel/purchase'

const TAB_KEY_DEMAND = 'demand'
const TAB_KEY_ORDERS = 'orders'

const tabs = [
  { key: TAB_KEY_DEMAND, path: `${PURCHASE_BASE}/demand`, label: 'Demanda', icon: <ClipboardList size={12.8} /> },
  { key: TAB_KEY_ORDERS, path: `${PURCHASE_BASE}/orders`, label: 'Pedidos', icon: <ShoppingCart size={12.8} /> },
]

export interface PurchaseOutletType {
  refresh: boolean
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>
}

const PurchaseContent = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState<string>(TAB_KEY_DEMAND)
  const [refresh, setRefresh] = useState(false)

  useEffect(() => {
    const path = location.pathname
    setActiveTab(path.includes(`${PURCHASE_BASE}/orders`) ? TAB_KEY_ORDERS : TAB_KEY_DEMAND)
  }, [location.pathname])

  const outletContext: PurchaseOutletType = { refresh, setRefresh }

  return (
    <>
      <PageHeader
        title='Compras'
        tabs={tabs.map(({ key, label, icon }) => ({ key, label, icon }))}
        activeTab={activeTab}
        onTabChange={(key) => {
          const tab = tabs.find((t) => t.key === key)
          if (tab && tab.key !== activeTab) navigate(tab.path)
        }}
        onReload={() => setRefresh((r) => !r)}
      />
      <Content>
        <Outlet context={outletContext} />
      </Content>
    </>
  )
}

export default PurchaseContent
